export const LOGIN = 'LOGIN'
export const SET_AUTHENTICATED_USER = 'SET_AUTHENTICATED_USER'
export const REFRESH_AUTHENTICATED_USER = 'REFRESH_AUTHENTICATED_USER'

export const CREATE_ACCOUNT = 'CREATE_ACCOUNT'
export const CREATE_ACCOUNT_USER_EXISTS = 'CREATE_ACCOUNT_USER_EXISTS'
export const LOGOUT = 'LOGOUT'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const SET_LATEST_CONFIRMED_WAITING_LIST = 'SET_LATEST_CONFIRMED_WAITING_LIST'

export const GET_TOKEN = 'GET_TOKEN'
export const SET_TOKEN = 'SET_TOKEN'
export const RESTORE_USER_SESSION = 'RESTORE_USER_SESSION'

export const PAYMENT_METHOD_TYPE_CREDIT_CARD = 'CREDIT_CARD'
export const PAYMENT_METHOD_TYPE_PAD = 'PREAUTHORIZED_DEBIT'
